import { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import { AppContext } from "../../context/AppContext";
import { Link } from "react-router-dom";

import "./Css/Category.css";
import Description from "./Description";
import SubCateegorySection from "./SubCateegorySection";

const Category = () => {
  const [category, setCategory] = useState([]);
  const {
    baseUrl,
    setgamelist,
    Backend_folder_path,
    pageType,
    setpagetype,
    descreption,
    setdescreption,
    setmetatag,
    metaTag,
  } = useContext(AppContext);
  const loaderRef = useRef(null);
  const [categoryType, setCatType] = useState("");
  const [items, setItems] = useState([]);
  const [showCatDiv, setshowCatDiv] = useState(false);

  let count = 0;

  useEffect(() => {
    handleSubmit();
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          // When loader div is visible, load more items

          setshowCatDiv((prev) => true);

          // setItems((prev) => [...prev, ...Array.from({ length: 5 }, (_, i) => prev.length + i + 1)]);
        }
      },
      { threshold: 1.0 } // fully visible
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await axios.get(`${baseUrl}/get-category`);
      if (response) {
        setCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error saving category:", error);
    }
  };

  const fetchCategoryGames = async (
    cat,
    id,
    cat_description,
    catType,
    meta
  ) => {
    try {
      //console.log("category",cat);
      const response = await axios.get(
        `${baseUrl}/getgame-categorywise/${cat}`
      );
      const responseAll = await axios.get(
        `${baseUrl}/getGameByCategoryInMenu/${id}`
      );
      //console.log("getGameByCategoryInMenu game", responseAll.data.gameLists);
      //setgamelist(responseAll.data.gameLists);
      const categoryGames = response?.data?.data || []; //only pure category wise games
      // games assigned to menu category but not having category field

      // if category game count is less than 30 then merge more games from menu category
      if (response.data?.data.length < 30) {
        const noCategoryGames = responseAll?.data?.gameLists || [];
        const mergedGames = [...categoryGames, ...noCategoryGames];
        // remove duplicates by id
        const uniqueGames = mergedGames.filter(
          (game, index, self) =>
            index === self.findIndex((g) => g.id === game.id)
        );
        console.log("uniq category games", uniqueGames);
        setgamelist(uniqueGames);
      } else {
        setgamelist(response.data.data);
      }

      //setgamelist(response.data.data);
      setCatType(catType);
      setpagetype("category");
      setdescreption(cat_description);
      setmetatag(meta);

      //console.log("gamelist catwise",response.data.data);
      //setCategoryWiseGames(response.data.data);
    } catch (err) {
      console.error("Error fetching games:", err);
    } finally {
    }
  };
  const getFileNameWithoutExt = (filePath = "") => {
    if (!filePath) return "";
    const parts = filePath.split("/");
    const lastPart = parts.pop();

    return lastPart.replace(/\.[^/.]+$/, ""); // removes last extension
  };
  return (
    <>
      <div className="category-container">
        <h2 ref={loaderRef} className="category-title">
          Game Categories
        </h2>
        {showCatDiv && (
          <div className="category-grid">
            {category.map(
              (cat) =>
                cat.categoryType === "category" && (
                  <Link
                    key={cat.id}
                    style={{ color: "white", textDecoration: "none" }}
                    to={`/${cat.name}`}
                  >
                    <div className="category-card">
                      <div
                        className="category-card-content"
                        onClick={() => {
                          fetchCategoryGames(
                            cat.name,
                            cat.id,
                            cat.description,
                            cat.categoryType,
                            cat.metatag
                          );
                          setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                          }, 100);
                        }}
                      >
                        <img
                          src={`${Backend_folder_path}${cat.image_path}`}
                          alt={getFileNameWithoutExt(cat.image_path)}
                          className="category-img"
                        />
                        <p className="category-name">
                          {cat.name
                            .replace(/-/g, " ") // replace all '-' with space
                            .replace(/\b\w/g, (char) =>
                              char.toUpperCase()
                            )}{" "}
                          {/* capitalize each word */}
                        </p>
                      </div>
                    </div>
                  </Link>
                )
            )}
          </div>
        )}

        <Description catDescription={descreption} />
        {/* {backToTop && (
          <div
            id="backToTop"
            onClick={()=>{window.scrollTo(0, 0);}}
            style={{ position: "fixed", bottom: 40, right: 10,cursor:'pointer' }}
          >
            <a >
              <img src="/gotop.webp" alt="top" />
            </a>
          </div>
        )} */}
      </div>
    </>
  );
};

export default Category;
